import { render } from "./FormGenerateOs.vue?vue&type=template&id=08f10824"
import script from "./FormGenerateOs.vue?vue&type=script&lang=js"
export * from "./FormGenerateOs.vue?vue&type=script&lang=js"

import "./FormGenerateOs.vue?vue&type=style&index=0&id=08f10824&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QOptionGroup,QTabPanels,QTabPanel});
